import type React from 'react';
import { ConfirmationDialog } from 'shared-portal-components-v2';

import { useCreateSixModal } from '@/hooks/createSix/useCreateSixModal';
import { CreateSixFormProvider } from '@/hooks/createSix/CreateSixFormContext';
import CreateSixStepper from '@/components/organism/CreateSix/CreateSixStepper';
import CreateSixWizardModal from '@/components/organism/CreateSix/CreateSixWizardModal';

function CreateSixModal(): React.JSX.Element | null {
  const { state, handlers } = useCreateSixModal();

  if (!state.isOpen) return null;

  const modalTitle = state.isEditMode ? 'Edit SIX' : 'Create a New SIX';
  const finalButtonText = state.isEditMode ? 'Save Changes' : 'Create SIX';

  return (
    <CreateSixFormProvider value={state.form}>
      <>
        <CreateSixWizardModal
          isOpen={state.isOpen}
          onClose={handlers.handleClose}
          title={<span className="tracking-tight text-2xl font-bold">{modalTitle}</span>}
          isLoading={state.isSubmitting}
          steps={state.wizardSteps}
          isFirstStep={state.isFirstStep}
          isLastStep={state.isLastStep}
          isNextDisabled={state.isNextDisabled}
          onPrevious={handlers.handlePrevious}
          onNext={handlers.handleNext}
          onCancel={handlers.handleClose}
          nextButtonText="Next"
          finalButtonText={finalButtonText}
        >
          <CreateSixStepper onClose={handlers.handleClose} />
        </CreateSixWizardModal>

        <ConfirmationDialog
          isOpen={state.isExternalConfirmationOpen}
          onClose={handlers.handleCloseExternalConfirmation}
          title="Proceed without adding the external user?"
          description="You have entered information to invite a new external user, but have not added them to the SIX. If you proceed without clicking 'Add to SIX', this new user information will not be saved and they will not receive a welcome email."
          onConfirm={handlers.handleConfirmExternalConfirmation}
          confirmText="Proceed to Review"
          cancelText="Keep Editing"
        />
      </>
    </CreateSixFormProvider>
  );
}

export default CreateSixModal;
